/**
 * AI Receptionist (BUILD-PLAN M15, owner WP3-RECEP): call log with the call
 * card, approval queue, insights, scripted test calls and the office
 * policies for the voice receptionist service.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'receptionist',
    title: 'AI Receptionist',
    version: '0.1.0',
    owner: 'WP3-RECEP',
    entitlementKey: 'ai_receptionist',
    permissions: ['comms.view', 'comms.send', 'settings.manage'],
    routes: [
      {
        id: 'home',
        path: '/receptionist',
        title: 'AI Receptionist',
        permission: 'comms.view',
        officeScope: 'location-or-all',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'AI Receptionist',
        group: 'operations',
        routeId: 'home',
        icon: 'sparkles',
        order: 20,
        permission: 'comms.view',
      },
    ],
    commands: [
      {
        id: 'receptionist.open',
        title: 'Open AI receptionist calls',
        keywords: ['receptionist', 'ai calls', 'after hours', 'virtual assistant', 'voice'],
        routeId: 'home',
        permission: 'comms.view',
      },
    ],
    sseEntityKeys: ['receptionist_call', 'receptionist_profile', 'booking_request'],
    phiReadPoints: ['receptionist.call_list', 'receptionist.call', 'receptionist.requests'],
  }),
  pages: {
    home: () => import('./ReceptionistPage.js'),
  },
});
